import { Link, useParams } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

import { Container } from "layout";
import { ApplyForm } from "components";
import { JobFacts } from "./JobFacts";
import { JobStatus } from "./JobStatus";
import { useJob } from "./useJob";

const ApplyPage = () => {
  const { id } = useParams();
  const state = useJob(id);

  if (state.status !== "ready") return <JobStatus state={state} />;
  const { job } = state;

  return (
    <Container isPage>
      <Link
        to={`/job/${encodeURIComponent(job.system.id)}`}
        className="mb-6 inline-flex items-center gap-2 rounded-lg border border-orange-200 px-4 py-2 font-medium text-orange-700 hover:bg-orange-50"
      >
        <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
        Back to the role
      </Link>
      <div className="flex flex-col-reverse gap-6 lg:flex-row lg:items-start lg:gap-10">
        <div className="min-w-0 flex-1">
          <ApplyForm job={job} />
        </div>
        <aside className="flex flex-col gap-4 rounded-2xl border border-orange-200 bg-orange-50 p-6 sm:p-8 lg:w-96">
          <p className="text-sm text-orange-800">You are applying for</p>
          <h1 className="text-2xl font-semibold text-gray-900 sm:text-3xl">
            {job.details.jobTitle}
          </h1>
          <JobFacts job={job.details} />
        </aside>
      </div>
    </Container>
  );
};

export default ApplyPage;
